import { KeyRound, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useToast } from '@/components/ui/toast';
import { useDeconnexion, useEtatAuth } from '../api/auth.api';
import { useSession } from '../useSession';
import { MotDePasseDialog } from './MotDePasseDialog';

/**
 * Pied de la barre latérale : qui est connecté, et par où sortir.
 *
 * Rien ne s'affiche hors du mode session — sous Cloudflare Access, se
 * déconnecter passe par Access, pas par l'application.
 */
export function MenuCompte() {
  const etat = useEtatAuth();
  const session = useSession();
  const deconnexion = useDeconnexion();
  const toast = useToast();
  const [dialogue, setDialogue] = useState(false);

  if (etat.data?.mode !== 'session' || !session) return null;

  const { email, nom } = session.utilisateur;
  const initiale = (nom ?? email).trim().charAt(0).toUpperCase();

  return (
    <>
      <div className="border-t border-white/10 px-3 py-3">
        <div className="flex items-center gap-2.5 px-2">
          <span
            aria-hidden
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full
              bg-mustard-500 text-xs font-semibold text-ink"
          >
            {initiale}
          </span>
          <span className="min-w-0 flex-1">
            {nom ? <span className="block truncate text-sm text-white">{nom}</span> : null}
            <span className="block truncate text-xs text-white/50" title={email}>
              {email}
            </span>
          </span>
        </div>

        <div className="mt-2 flex gap-1">
          <button
            type="button"
            onClick={() => setDialogue(true)}
            className="flex flex-1 items-center gap-2 rounded-md px-2 py-1.5 text-xs
              text-white/70 transition-colors hover:bg-white/5 hover:text-white"
          >
            <KeyRound aria-hidden className="h-3.5 w-3.5" />
            Mot de passe
          </button>
          <button
            type="button"
            disabled={deconnexion.isPending}
            onClick={() => {
              deconnexion.mutate(undefined, {
                onSettled: () => toast.info('Vous êtes déconnecté.'),
              });
            }}
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-xs
              text-white/70 transition-colors hover:bg-white/5 hover:text-white
              disabled:opacity-50"
          >
            <LogOut aria-hidden className="h-3.5 w-3.5" />
            Quitter
          </button>
        </div>
      </div>

      <MotDePasseDialog ouvert={dialogue} onFermer={() => setDialogue(false)} />
    </>
  );
}
